import React, {Component} from "react";
import msparcs from "assets/img/msparcs.png";
import ColumnChart from 'components/amcharts/ColumnChart';
import LineChart from 'components/amcharts/LineChart';
import PieChart from 'components/amcharts/PieChart';
import StackedColumnChart from 'components/amcharts/StackedColumnChart';
import AreaChart from 'components/amcharts/AreaChart';
import BubbleChart from 'components/amcharts/BubbleChart';
import BarChart from 'components/amcharts/BarChart';

import {Card} from 'components/Card/Card.jsx';
import {UserCard} from 'components/UserCard/UserCard.jsx';
import {StatsCard} from 'components/StatsCard/StatsCard.jsx';
import ChartistGraph from "react-chartist";


// Tabular with Pia chart
import {
    Nav, NavItem,
    Tab
} from 'react-bootstrap';
import ReactTooltip from "react-tooltip";


// Data Chart First Data for Line Chart
var dataSales = {
    labels: ['29-Jan-2020', '30-Jan-2020', '31-Jan-2020', '1-Feb-2020', '2-Feb-2020', '3-Feb-2020', '4-Feb-2020'],
    series: [
        [20, 25, 28, 40, 35, 29, 45],
        [18, 30, 35, 20, 40, 45, 20],
    ]
};
var optionsSales = {
    low: 0,
    high: 50,
    showArea: false,
    height: "245px",
    axisX: {
        showGrid: false,
    },
    lineSmooth: true,
    showLine: true,
    showPoint: true,
    fullWidth: true,
    chartPadding: {
        right: 50
    }
};
var responsiveSales = [
    ['screen and (max-width: 640px)', {
        axisX: {
            labelInterpolationFnc: function (value) {
                return value[0];
            }
        }
    }]
];


// Data Chart Second
var dataBar = {
    labels: ['29-Jan-2020', '30-Jan-2020', '31-Jan-2020', '1-Feb-2020', '2-Feb-2020', '3-Feb-2020', '4-Feb-2020'],
    series: [
        [20, 25, 28, 40, 35, 29, 45],
        [18, 28, 30, 30, 40, 25, 40],
    ]
};
var optionsBar = {
    seriesBarDistance: 10,
    axisX: {
        showGrid: false
    },
    height: "245px"
};
var responsiveBar = [
    ['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
            labelInterpolationFnc: function (value) {
                return value[0];
            }
        }
    }]
];

class MerchantDashboard extends Component {
    dataBar = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
            [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
        ]
    };
    optionsBar = {
        seriesBarDistance: 10,
        axisX: {
            showGrid: false
        },
        height: "245px"
    };
    responsiveBar = [
        ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
            axisX: {
                labelInterpolationFnc: function (value) {
                    return value[0];
                }
            }
        }]
    ];


    state = {
        data: [],
        chartHeight: "250px",
        tblData: [
            {id: 1, Name: 'AA', subject: 'Math', marks: 78},
            {id: 2, Name: 'BB', subject: 'Hindi', marks: 88},
            {id: 3, Name: 'CC', subject: 'English', marks: 68},
            {id: 4, Name: 'DD', subject: 'Science', marks: 77},
            {id: 5, Name: 'EE', subject: 'S Science', marks: 65},
        ],
    };

    componentWillMount() {

        let SalesData = [{
            "country": "USA",
            "visits": 2025
        }, {
            "country": "China",
            "visits": 1882
        }, {
            "country": "Japan",
            "visits": 1809
        }, {
            "country": "Germany",
            "visits": 1322
        }, {
            "country": "UK",
            "visits": 1122
        }, {
            "country": "France",
            "visits": 1114
        }, {
            "country": "India",
            "visits": 984
        }, {
            "country": "Spain",
            "visits": 711
        }, {
            "country": "Netherlands",
            "visits": 665
        }, {
            "country": "Russia",
            "visits": 580
        }, {
            "country": "South Korea",
            "visits": 443
        }, {
            "country": "Canada",
            "visits": 441
        }, {
            "country": "Brazil",
            "visits": 395
        }];
        this.setState({
            data: SalesData,
            chartHeight: "250px"
        });
    }

    render() {

        let tblTH = Object.keys(this.state.tblData[0]).map(function (Head) {
            return <th> {Head} </th>
        });

        let tblTD = this.state.tblData.map((data, index) => {
            return (
                <tr>{

                    Object.values(data).map(function (subData) {
                        return <td>{subData}</td>
                    })
                }
                </tr>
            )
        });

        let colCount = Object.keys(this.state.tblData[0]).length;
        let colWith = '';
        if (colCount > 5) {
            colWith = 'col-lg-12';
        } else {
            colWith = 'col-lg-6';
        }

        return (
            <div className="content">
                <div className="container-fluid   p-t-5">
                    <div className="row d-flex">
                        {/*pnc*/}
                        <div className={colWith + "  remove-footer"} style={{height: "auto"}}>
                            <div className="card card-stats content">

                                <div className="content table-full-width table-responsive">
                                    <table className="table table-striped table-hover" >
                                        <thead>
                                        <tr>
                                            {tblTH}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tblTD}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 remove-footer">
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"></i>}
                                statsText="Total Volume of Transaction"
                                statsValue="1,345"
                            />
                        </div>
                        <div className="col-lg-3 remove-footer">
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"></i>}
                                statsText="Innoviti's EDC Deployment"
                                statsValue="1,345"
                            />
                        </div>
                        <div className="col-lg-3 remove-footer">
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"></i>}
                                statsText="Innoviti's EDC Deployment"
                                statsValue="1,345"
                            />
                        </div>

                        <div className="col-lg-3 remove-footer">
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"></i>}
                                statsText="Innoviti's EDC Deployment"
                                statsValue="1,345"
                            />
                        </div>
                        <div className="col-lg-3 remove-footer">
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"></i>}
                                statsText="Innoviti's EDC Deployment"
                                statsValue="1,345"
                            />
                        </div>

                        <div className="col-lg-3 remove-footer">
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"></i>}
                                statsText="Innoviti's EDC Deployment"
                                statsValue="1,345"
                            />
                        </div>


                    </div>
                </div>

                <div className="container-fluid space-container-fluid">
                    <div className="row">
                        <div className="col-md-4 col-xs-12">
                            <Card
                                title="Total Transaction Amount (lakhs, ₹)"
                                content={
                                    <div id="chartActivity" className="ct-chart">
                                        <ChartistGraph
                                            data={dataSales}
                                            type="Line"
                                            options={optionsSales}
                                            responsiveOptions={responsiveSales}/>
                                    </div>
                                }
                                legend={
                                    <div className="legend d-block text-center">
                                        <small className="d-block">
                                            <i className="fa fa-circle text-info"></i> Transaction Count (10000)
                                        </small>
                                        <small className="d-block">
                                            <i className="fa fa-circle text-danger"></i> Total Transaction Amount
                                        </small>
                                    </div>
                                }
                            />
                        </div>

                        <div className="col-md-4 col-xs-12">
                            <Card
                                title="Monthly Transaction"
                                content={
                                    <div id="chartActivity" className="ct-chart">
                                        <ChartistGraph
                                            data={dataBar}
                                            type="Line"
                                            options={optionsBar}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend d-block text-center">
                                        <small className="d-block">
                                            <i className="fa fa-circle text-info"></i> Transaction Count (10000)
                                        </small>
                                        <small className="d-block">
                                            <i className="fa fa-circle text-danger"></i> Total Transaction Amount
                                        </small>
                                    </div>
                                }
                            />
                        </div>
                        <div className="col-md-4 col-xs-12">
                            <Card
                                title="Transaction Routing and Success Rate [count]"
                                content={
                                    <div id="chartActivity" className="ct-chart">
                                        <ChartistGraph
                                            data={dataBar}
                                            type="Bar"
                                            options={optionsBar}
                                            responsiveOptions={responsiveBar}
                                        />
                                    </div>
                                }
                                legend={
                                    <div className="legend d-block text-center">
                                        <small className="d-block">
                                            <i className="fa fa-circle text-info"></i> Transaction Count (10000)
                                        </small>
                                        <small className="d-block">
                                            <i className="fa fa-circle text-danger"></i> Total Transaction Amount
                                        </small>
                                    </div>
                                }
                            />
                        </div>


                    </div>
                    <div className="row m-0">
                        <Tab.Container id="nav-with-icons" defaultActiveKey="volume">
                            <div>
                                <div className="nav-container">
                                    <Nav bsStyle="tabs" bsclassName="nav nav-icons">
                                        <NavItem eventKey="volume">
                                            Volume
                                        </NavItem>
                                        <NavItem eventKey="count">
                                            Count
                                        </NavItem>
                                    </Nav>
                                </div>
                                <Tab.Content className="tab-content-style">
                                    <Tab.Pane eventKey="volume" className="row">
                                        <div className="col-md-4 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Transaction Amount <br/> by Acquiring Bank
                                                        (lakhs, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Total Transaction <br/> Amount (lakhs, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <PieChart data={this.state.data}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Transaction Amount <br/> by Card Type(lakhs,
                                                        ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <PieChart data={this.state.data}/>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="count" className="row">
                                        <div className="col-md-4 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Transaction Amount <br/> by Acquiring Bank
                                                        (lakhs, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <LineChart data={this.state.data}
                                                               chartHeight={this.state.chartHeight}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Total Transaction <br/> Amount (lakhs, ₹)</h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <PieChart data={this.state.data}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-xs-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h4 className="title">Transaction Amount <br/>by Card Type(lakhs, ₹)
                                                    </h4>
                                                    {/*<p className="category">24 Hours performance</p>*/}
                                                </div>
                                                <div className="ChartContent">
                                                    <PieChart data={this.state.data}/>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>

                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
            </div>

        );

    }


}

export default MerchantDashboard;